export const Moves: {[k: string]: ModdedMoveData} = {
	accelerock: {
		inherit: true,
		isNonstandard: "Past",
	},
	anchorshot: {
		inherit: true,
		isNonstandard: "Past",
	},
	appleacid: {
		inherit: true,
		isNonstandard: "Past",
	},
	astralbarrage: {
		inherit: true,
		isNonstandard: "Past",
	},
	aurawheel: {
		inherit: true,
		isNonstandard: "Past",
	},
	banefulbunker: {
		inherit: true,
		isNonstandard: "Past",
	},
	behemothbash: {
		inherit: true,
		isNonstandard: "Past",
	},
	behemothblade: {
		inherit: true,
		isNonstandard: "Past",
	},
	blueflare: {
		inherit: true,
		isNonstandard: "Past",
	},
	boltbeak: {
		inherit: true,
		isNonstandard: "Past",
	},
	boltstrike: {
		inherit: true,
		isNonstandard: "Past",
	},
	branchpoke: {
		inherit: true,
		isNonstandard: "Past",
	},
	breakingswipe: {
		inherit: true,
		isNonstandard: "Past",
	},
	brutalswing: {
		inherit: true,
		isNonstandard: "Past",
	},
	burningjealousy: {
		inherit: true,
		isNonstandard: "Past",
	},
	celebrate: {
		inherit: true,
		isNonstandard: "Past",
	},
	chatter: {
		inherit: true,
		isNonstandard: null,
	},
	clangingscales: {
		inherit: true,
		isNonstandard: "Past",
	},
	clangoroussoul: {
		inherit: true,
		isNonstandard: "Past",
	},
	coaching: {
		inherit: true,
		isNonstandard: "Past",
	},
	coreenforcer: {
		inherit: true,
		isNonstandard: "Past",
	},
	corrosivegas: {
		inherit: true,
		isNonstandard: "Past",
	},
	courtchange: {
		inherit: true,
		isNonstandard: "Past",
	},
	craftyshield: {
		inherit: true,
		isNonstandard: "Past",
	},
	darkestlariat: {
		inherit: true,
		isNonstandard: "Past",
	},
	darkvoid: {
		inherit: true,
		isNonstandard: null,
	},
	decorate: {
		inherit: true,
		isNonstandard: "Past",
	},
	diamondstorm: {
		inherit: true,
		isNonstandard: "Past",
	},
	doubleironbash: {
		inherit: true,
		isNonstandard: "Past",
	},
	dragondarts: {
		inherit: true,
		isNonstandard: "Past",
	},
	dragonenergy: {
		inherit: true,
		isNonstandard: "Past",
	},
	dragonhammer: {
		inherit: true,
		flags: {contact: 1, protect: 1, mirror: 1, metronome: 1},
	},
	drumbeating: {
		inherit: true,
		isNonstandard: "Past",
	},
	dualwingbeat: {
		inherit: true,
		isNonstandard: "Past",
	},
	dynamaxcannon: {
		inherit: true,
		isNonstandard: "Past",
	},
	eeriespell: {
		inherit: true,
		isNonstandard: "Past",
	},
	electrify: {
		inherit: true,
		isNonstandard: "Past",
	},
	electroweb: {
		inherit: true,
		isNonstandard: "Past",
	},
	eternabeam: {
		inherit: true,
		isNonstandard: "Past",
	},
	expandingforce: {
		inherit: true,
		isNonstandard: "Past",
	},
	fairylock: {
		inherit: true,
		isNonstandard: "Past",
	},
	falsesurrender: {
		inherit: true,
		isNonstandard: "Past",
	},
	fierydance: {
		inherit: true,
		isNonstandard: "Past",
	},
	fierywrath: {
		inherit: true,
		isNonstandard: "Past",
	},
	firelash: {
		inherit: true,
		isNonstandard: "Past",
	},
	firepledge: {
		inherit: true,
		isNonstandard: "Past",
	},
	firstimpression: {
		inherit: true,
		isNonstandard: "Past",
	},
	fishiousrend: {
		inherit: true,
		isNonstandard: "Past",
	},
	flash: {
		inherit: true,
		isNonstandard: null,
	},
	fleurcannon: {
		inherit: true,
		isNonstandard: "Past",
	},
	flipturn: {
		inherit: true,
		isNonstandard: "Past",
	},
	floralhealing: {
		inherit: true,
		isNonstandard: "Past",
	},
	flyingpress: {
		inherit: true,
		isNonstandard: "Past",
	},
	forestscurse: {
		inherit: true,
		isNonstandard: "Past",
	},
	freezeshock: {
		inherit: true,
		isNonstandard: "Past",
	},
	freezingglare: {
		inherit: true,
		isNonstandard: "Past",
	},
	fusionbolt: {
		inherit: true,
		isNonstandard: "Past",
	},
	fusionflare: {
		inherit: true,
		isNonstandard: "Past",
	},
	geargrind: {
		inherit: true,
		isNonstandard: "Past",
	},
	gearup: {
		inherit: true,
		isNonstandard: "Past",
	},
	geomancy: {
		inherit: true,
		isNonstandard: "Past",
	},
	glaciallance: {
		inherit: true,
		isNonstandard: "Past",
	},
	glaciate: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxbefuddle: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxcannonade: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxcentiferno: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxchistrike: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxcuddle: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxdepletion: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxdrumsolo: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxfinale: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxfireball: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxfoamburst: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxgoldrush: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxgravitas: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxhydrosnipe: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxmalodor: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxmeltdown: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxoneblow: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxrapidflow: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxreplenish: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxresonance: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxsandblast: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxsmite: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxsnooze: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxsteelsurge: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxstonesurge: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxstunshock: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxsweetness: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxtartness: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxterror: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxvinelash: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxvolcalith: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxvoltcrash: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxwildfire: {
		inherit: true,
		isNonstandard: "Past",
	},
	gmaxwindrage: {
		inherit: true,
		isNonstandard: "Past",
	},
	grasspledge: {
		inherit: true,
		isNonstandard: "Past",
	},
	grassyglide: {
		inherit: true,
		isNonstandard: "Past",
	},
	gravapple: {
		inherit: true,
		isNonstandard: "Past",
	},
	happyhour: {
		inherit: true,
		isNonstandard: "Past",
	},
	headcharge: {
		inherit: true,
		isNonstandard: "Past",
	},
	heartswap: {
		inherit: true,
		isNonstandard: null,
	},
	heatcrash: {
		inherit: true,
		isNonstandard: "Past",
	},
	hiddenpower: {
		inherit: true,
		isNonstandard: null,
	},
	hiddenpowerbug: {
		inherit: true,
		isNonstandard: null,
	},
	hiddenpowerdark: {
		inherit: true,
		isNonstandard: null,
	},
	hiddenpowerdragon: {
		inherit: true,
		isNonstandard: null,
	},
	hiddenpowerelectric: {
		inherit: true,
		isNonstandard: null,
	},
	hiddenpowerfighting: {
		inherit: true,
		isNonstandard: null,
	},
	hiddenpowerfire: {
		inherit: true,
		isNonstandard: null,
	},
	hiddenpowerflying: {
		inherit: true,
		isNonstandard: null,
	},
	hiddenpowerghost: {
		inherit: true,
		isNonstandard: null,
	},
	hiddenpowergrass: {
		inherit: true,
		isNonstandard: null,
	},
	hiddenpowerground: {
		inherit: true,
		isNonstandard: null,
	},
	hiddenpowerice: {
		inherit: true,
		isNonstandard: null,
	},
	hiddenpowerpoison: {
		inherit: true,
		isNonstandard: null,
	},
	hiddenpowerpsychic: {
		inherit: true,
		isNonstandard: null,
	},
	hiddenpowerrock: {
		inherit: true,
		isNonstandard: null,
	},
	hiddenpowersteel: {
		inherit: true,
		isNonstandard: null,
	},
	hiddenpowerwater: {
		inherit: true,
		isNonstandard: null,
	},
	holdback: {
		inherit: true,
		isNonstandard: "Past",
	},
	holdhands: {
		inherit: true,
		isNonstandard: "Past",
	},
	hornleech: {
		inherit: true,
		isNonstandard: "Past",
	},
	iceburn: {
		inherit: true,
		isNonstandard: "Past",
	},
	instruct: {
		inherit: true,
		isNonstandard: "Past",
	},
	jawlock: {
		inherit: true,
		isNonstandard: "Past",
	},
	judgment: {
		inherit: true,
		isNonstandard: null,
	},
	junglehealing: {
		inherit: true,
		isNonstandard: "Past",
	},
	kingsshield: {
		inherit: true,
		isNonstandard: "Past",
	},
	landswrath: {
		inherit: true,
		isNonstandard: "Past",
	},
	lashout: {
		inherit: true,
		isNonstandard: "Past",
	},
	magicpowder: {
		inherit: true,
		isNonstandard: "Past",
	},
	matblock: {
		inherit: true,
		isNonstandard: "Past",
	},
	maxairstream: {
		inherit: true,
		isNonstandard: "Past",
	},
	maxdarkness: {
		inherit: true,
		isNonstandard: "Past",
	},
	maxflare: {
		inherit: true,
		isNonstandard: "Past",
	},
	maxflutterby: {
		inherit: true,
		isNonstandard: "Past",
	},
	maxgeyser: {
		inherit: true,
		isNonstandard: "Past",
	},
	maxguard: {
		inherit: true,
		isNonstandard: "Past",
	},
	maxhailstorm: {
		inherit: true,
		isNonstandard: "Past",
	},
	maxknuckle: {
		inherit: true,
		isNonstandard: "Past",
	},
	maxlightning: {
		inherit: true,
		isNonstandard: "Past",
	},
	maxmindstorm: {
		inherit: true,
		isNonstandard: "Past",
	},
	maxooze: {
		inherit: true,
		isNonstandard: "Past",
	},
	maxovergrowth: {
		inherit: true,
		isNonstandard: "Past",
	},
	maxphantasm: {
		inherit: true,
		isNonstandard: "Past",
	},
	maxquake: {
		inherit: true,
		isNonstandard: "Past",
	},
	maxrockfall: {
		inherit: true,
		isNonstandard: "Past",
	},
	maxstarfall: {
		inherit: true,
		isNonstandard: "Past",
	},
	maxsteelspike: {
		inherit: true,
		isNonstandard: "Past",
	},
	maxstrike: {
		inherit: true,
		isNonstandard: "Past",
	},
	maxwyrmwind: {
		inherit: true,
		isNonstandard: "Past",
	},
	meteorassault: {
		inherit: true,
		isNonstandard: "Past",
	},
	meteorbeam: {
		inherit: true,
		isNonstandard: "Past",
	},
	metronome: {
		inherit: true,
		desc: "A random move is selected for use, other than After You, Belch, Body Press, Chatter, Copycat, Counter, Covet, Destiny Bond, Detect, Dragon Ascent, Endure, Feint, Focus Punch, Follow Me, Helping Hand, Life Dew, Metronome, Mimic, Mirror Coat, Nature Power, Origin Pulse, Precipice Blades, Protect, Quash, Quick Guard, Rage Powder, Sketch, Sleep Talk, Snarl, Snore, Spiky Shield, Struggle, Switcheroo, Thief, Transform, Trick, or Wide Guard.",
		shortDesc: "Picks a random move.",
	},
	mindblown: {
		inherit: true,
		isNonstandard: "Past",
	},
	mistyexplosion: {
		inherit: true,
		isNonstandard: "Past",
	},
	moongeistbeam: {
		inherit: true,
		isNonstandard: "Past",
	},
	multiattack: {
		inherit: true,
		isNonstandard: "Past",
	},
	naturesmadness: {
		inherit: true,
		isNonstandard: "Past",
	},
	nightdaze: {
		inherit: true,
		isNonstandard: "Past",
	},
	noretreat: {
		inherit: true,
		isNonstandard: "Past",
	},
	oblivionwing: {
		inherit: true,
		isNonstandard: "Past",
	},
	obstruct: {
		inherit: true,
		isNonstandard: "Past",
	},
	octolock: {
		inherit: true,
		isNonstandard: "Past",
	},
	overdrive: {
		inherit: true,
		isNonstandard: "Past",
	},
	paraboliccharge: {
		inherit: true,
		isNonstandard: "Past",
	},
	photongeyser: {
		inherit: true,
		isNonstandard: "Past",
	},
	plasmafists: {
		inherit: true,
		isNonstandard: "Past",
	},
	pollenpuff: {
		inherit: true,
		isNonstandard: "Past",
	},
	poltergeist: {
		inherit: true,
		isNonstandard: "Past",
	},
	powertrip: {
		inherit: true,
		isNonstandard: "Past",
	},
	prismaticlaser: {
		inherit: true,
		isNonstandard: "Past",
	},
	psychicfangs: {
		inherit: true,
		isNonstandard: "Past",
	},
	psychicterrain: {
		inherit: true,
		isNonstandard: "Past",
	},
	psychoboost: {
		inherit: true,
		isNonstandard: null,
	},
	purify: {
		inherit: true,
		isNonstandard: "Past",
	},
	pyroball: {
		inherit: true,
		isNonstandard: "Past",
	},
	risingvoltage: {
		inherit: true,
		isNonstandard: "Past",
	},
	rockclimb: {
		inherit: true,
		isNonstandard: null,
	},
	sacredsword: {
		inherit: true,
		isNonstandard: "Past",
	},
	scaleshot: {
		inherit: true,
		isNonstandard: "Past",
	},
	scorchingsands: {
		inherit: true,
		isNonstandard: "Past",
	},
	searingshot: {
		inherit: true,
		isNonstandard: "Past",
	},
	secretsword: {
		inherit: true,
		isNonstandard: "Past",
	},
	seedflare: {
		inherit: true,
		isNonstandard: null,
	},
	shadowbone: {
		inherit: true,
		isNonstandard: "Past",
	},
	shellsidearm: {
		inherit: true,
		isNonstandard: "Past",
	},
	shelltrap: {
		inherit: true,
		isNonstandard: "Past",
	},
	shiftgear: {
		inherit: true,
		isNonstandard: "Past",
	},
	shoreup: {
		inherit: true,
		isNonstandard: "Past",
	},
	sketch: {
		inherit: true,
		isNonstandard: null,
	},
	skittersmack: {
		inherit: true,
		isNonstandard: "Past",
	},
	snaptrap: {
		inherit: true,
		isNonstandard: "Past",
	},
	snipeshot: {
		inherit: true,
		isNonstandard: "Past",
	},
	solarblade: {
		inherit: true,
		isNonstandard: "Past",
	},
	sparklingaria: {
		inherit: true,
		isNonstandard: "Past",
	},
	spectralthief: {
		inherit: true,
		isNonstandard: "Past",
	},
	speedswap: {
		inherit: true,
		isNonstandard: "Past",
	},
	spiritbreak: {
		inherit: true,
		isNonstandard: "Past",
	},
	spiritshackle: {
		inherit: true,
		isNonstandard: "Past",
	},
	steameruption: {
		inherit: true,
		isNonstandard: "Past",
	},
	steelbeam: {
		inherit: true,
		isNonstandard: "Past",
	},
	steelroller: {
		inherit: true,
		isNonstandard: "Past",
	},
	strangesteam: {
		inherit: true,
		isNonstandard: "Past",
	},
	stuffcheeks: {
		inherit: true,
		isNonstandard: "Past",
	},
	sunsteelstrike: {
		inherit: true,
		isNonstandard: "Past",
	},
	surgingstrikes: {
		inherit: true,
		isNonstandard: "Past",
	},
	tailglow: {
		inherit: true,
		isNonstandard: null,
	},
	tailslap: {
		inherit: true,
		isNonstandard: "Past",
	},
	tarshot: {
		inherit: true,
		isNonstandard: "Past",
	},
	teatime: {
		inherit: true,
		isNonstandard: "Past",
	},
	technoblast: {
		inherit: true,
		isNonstandard: "Past",
	},
	terrainpulse: {
		inherit: true,
		isNonstandard: "Past",
	},
	thousandarrows: {
		inherit: true,
		isNonstandard: "Past",
	},
	thousandwaves: {
		inherit: true,
		isNonstandard: "Past",
	},
	thundercage: {
		inherit: true,
		isNonstandard: "Past",
	},
	thunderouskick: {
		inherit: true,
		isNonstandard: "Past",
	},
	topsyturvy: {
		inherit: true,
		isNonstandard: "Past",
	},
	toxicthread: {
		inherit: true,
		isNonstandard: null,
	},
	trickortreat: {
		inherit: true,
		isNonstandard: "Past",
	},
	tripleaxel: {
		inherit: true,
		isNonstandard: "Past",
	},
	tropkick: {
		inherit: true,
		isNonstandard: "Past",
	},
	vcreate: {
		inherit: true,
		isNonstandard: "Past",
	},
	waterpledge: {
		inherit: true,
		isNonstandard: "Past",
	},
	watershuriken: {
		inherit: true,
		isNonstandard: "Past",
	},
	wickedblow: {
		inherit: true,
		isNonstandard: "Past",
	},
	zingzap: {
		inherit: true,
		isNonstandard: "Past",
	},
};
